<template>
  <div class="rank-rule-wrapper">
    <div class="rank-rule-header">
      <Row type="flex" align="center">
        <Col :span="12" class="rank-rule-title">
          <div class="rank-rule-title__text">活动规则</div>
          <div class="text-bottom-shadow"></div>
        </Col>
        <Col :span="12" class="rank-rule-bg">
          <img class="rank-rule-bg__1" src="../../assets/ranking/rule_bg_1.png">
          <img class="rank-rule-bg__2" src="../../assets/ranking/rule_bg_2.png">
        </Col>
      </Row>
    </div>
    <div class="rank-rule-content">
      <RuleItem :no="1" title="车队本周发帖统计规则">
        统计本周该车队所有成员发帖数量，包括动态、文章和转载，动态内容、文章和转载标题包含本车队口号，每小时整点刷新一次
      </RuleItem>
      <RuleItem :no="2" title="个人本周发帖统计规则">
        统计本周参与活动车队成员发帖数量，包括动态、文章和转载，动态内容、文章和转载标题包含所属车队口号，每小时整点刷新一次
      </RuleItem>
      <RuleItem :no="3" title="车队积分规则">
        周榜积分核算：每周一计算上周发帖总量
        周发帖总数排名第一：5分<br/>
        周发帖总数排名第二：3分<br/>
        周发帖总数排名第三：2分<br/>
        月榜积分核算：当月4周积分总和<br/>
        总榜积分核算：所有积分总和<br/>
      </RuleItem>
      <RuleItem :no="4" title="个人积分规则">
        周榜积分核算：每周一计算上周发帖总量<br/>
        周发帖总数排名第一：5分<br/>
        周发帖总数排名第二：3分<br/>
        周发帖总数排名第三：2分<br/>
        月榜积分核算：当月4周积分总和<br/>
        总榜积分核算：所有积分总和<br/>
      </RuleItem>
      <RuleItem :no="5" title="发帖数计算规则">
        发帖数计算规则<br/>
        发布动态、文章和转载，动态内容、文章和转载标题包含指定口号+1条，删除贴子扣除对应条数<br/>
      </RuleItem>
    </div>
    <div class="rank-rule-end">
      活动解释权归宗申•比亚乔佛山摩托车企业有限公司所有
    </div>
  </div>
</template>

<script>
// 发帖/积分排行榜活动规则
import { Row, Col } from 'vant'
import RuleItem from './RuleItem'
export default {
  name: 'RankRule',
  components: { Row, Col, RuleItem },
  props: {},
  created () {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="less">
.rank-rule{
  &-item{
    margin-bottom: 20px;
  }
  &-wrapper{
    background: linear-gradient(153deg,rgba(57,90,245,1) 0%,rgba(66,35,191,1) 100%);
    padding: 0 16px;
  }
  &-header{
    padding: 20px 0 36px;
  }
  &-title{
    position: relative;
    font-size: 28px;
    color: #fff;
    font-weight: 800;
    padding-left: 27px;
    &__text{
      position: absolute;
      bottom: -40px;
      z-index: 2;
    }
    .text-bottom-shadow{
      position: absolute;
      background-color: #2d3e86;
      width: 104px;
      height: 16.5px;
      bottom: -43px;
      z-index: 1;
    }
  }
  &-bg{
    position: relative;
    &__1{
      width: 138.5px;
      height: 49px;
    }
    &__2{
      position: absolute;
      top: 23px;
      left: 31.5px;
      width: 79px;
      height: 110.5px;
    }
  }
  &-content{
    background-color: #fff;
    border-radius: 5px;
    padding: 50px 24px 30px;
  }
  &-end{
    font-size: 13px;
    text-align: center;
    padding-top: 20px;
    color: #fff;
    padding-bottom: 40px;
    opacity: 0.5;
  }
}
</style>
